import * as Yup from 'yup';

export function newLocationSchema(shouldValidateAddress = true) {
  return Yup.object().shape({
    residence: Yup.object().shape({
      address: shouldValidateAddress
        ? Yup.object().nullable().shape({
            address: Yup.string(),
            calendar: Yup.string(),
            calendarName: Yup.string(),
            dropoffProcedureInstructions: Yup.string(),
            group: Yup.string(),
            id: Yup.string(),
            label: Yup.string(),
            latLng: Yup.string(),
            locationType: Yup.string(),
            name: Yup.string(),
            passengerCount: Yup.string(),
            pickupProcedureInstructions: Yup.string(),
            placeId: Yup.string(),
          })
        : Yup.object().nullable(),
      streetAddressTwo: Yup.string().trim(),
    }),
  });
}
